import { RouteComponentProps, withRouter } from 'react-router-dom';
import LoginContainer from '../components/LoginPages/LoginContainer';
import LoginRoutes from '../components/LoginPages/Routes';

const Login: React.FunctionComponent<RouteComponentProps> = (_props: RouteComponentProps) => (
  <LoginContainer>
    <LoginRoutes />
  </LoginContainer>
);

export default withRouter(Login);
